<div class="branches-tree-wrapper">

  @if (data && data.length) {
  <!-- ===================================================== -->
  <!-- Header -->
  <!-- ===================================================== -->

  <div class="d-flex align-items-center justify-content-between mb-3 gap-3">


    <!-- Select All -->

    <div class="select-all-box">

      <mat-checkbox [checked]="isAllSelected()" [indeterminate]="isMasterIndeterminate()" (change)="masterToggle()"
        [disabled]="isDisabled" color="primary">

        {{ 'general.selectAll' | translate }}

      </mat-checkbox>

    </div>


    <!-- Search -->

    <div class="search-box flex-grow-1">

      <mat-form-field appearance="outline" class="w-100 search-field">


        <mat-icon matPrefix>

          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15.997" viewBox="0 0 16 15.997">

            <path id="search"
              d="M17.754,16.627l-2.966-2.944A7.194,7.194,0,1,0,13.677,14.8l2.942,2.944a.795.795,0,0,0,1.135-1.112ZM9.192,14.8a5.6,5.6,0,1,1,5.6-5.6,5.6,0,0,1-5.6,5.6Z"
              transform="translate(-1.979 -1.979)" fill="#8e8fa2">
            </path>

          </svg>

        </mat-icon>


        <input matInput (keyup)="filterBranches($event)" [disabled]="isDisabled"
          [placeholder]="'offers.searchForBranch' | translate">

      </mat-form-field>

    </div>

  </div>


  <!-- ===================================================== -->
  <!-- Physical Branches -->
  <!-- ===================================================== -->
  @if (dataSource && dataSource.data && dataSource.data.length) {
  <div class="branches-tree-container border rounded">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="branches-tree">


      <!-- ================================================= -->
      <!-- Leaf / Physical Branch -->
      <!-- ================================================= -->

      <mat-tree-node *matTreeNodeDef="let node" class="tree-leaf-node">


        <mat-checkbox class="checklist-leaf-node ms-auto" [checked]="isNodeSelected(node)"
          (change)="toggleLeafSelection(node)" [disabled]="isDisabled" color="primary">

          {{ node.name }}

        </mat-checkbox>


      </mat-tree-node>


      <!-- ================================================= -->
      <!-- City / Parent -->
      <!-- ================================================= -->

      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">


        <div class="mat-tree-node tree-parent-node">


          <!-- Expand / Collapse -->

          <button mat-icon-button matTreeNodeToggle type="button">

            <mat-icon class="mat-icon-rtl-mirror">

              {{
              treeControl.isExpanded(node)
              ? 'expand_less'
              : 'expand_more'
              }}

            </mat-icon>

          </button>


          <!-- City checkbox -->

          <mat-checkbox [checked]="isParentSelected(node)" [indeterminate]="isParentIndeterminate(node)"
            (change)="toggleNodeSelection(node)" [disabled]="isDisabled" color="primary" class="ms-auto">

            {{ node.name }}

          </mat-checkbox>


        </div>


        <!-- Children -->

        <div [class.tree-invisible]="
            !treeControl.isExpanded(node)
          " role="group" class="tree-child-container">

          <ng-container matTreeNodeOutlet>
          </ng-container>

        </div>


      </mat-nested-tree-node>


    </mat-tree>
  </div>
  }

  @if (searchQuery && !dataSource.data.length) {
  <div class="p-3 text-center text-muted">
    {{ 'general.noResults' | translate }}
  </div>
  }

  }
  <!-- ===================================================== -->
  <!-- Electronic Branch -->
  <!-- ===================================================== -->

  <div *ngIf="electronicBranch" class="electronic-branch-container border rounded mt-3">


    <mat-checkbox class="w-100" [checked]="isElectronicBranchSelected()" (change)="toggleElectronicBranch()"
      [disabled]="isDisabled" color="primary">

      {{ electronicBranch.name }}

    </mat-checkbox>


  </div>

</div>
